import classNames from "classnames";

import PresentationEditorController from "js/editor/PresentationEditor/PresentationEditorController";
import React, { Component } from "react";
import { Subscription } from "rxjs";
import styled from "styled-components";
import CommentsPane from "./CommentsPane";
import { PropertyPanelHeader } from "js/editor/ElementEditor/PropertyPanelHeader";

const Bottom = styled.div`
    height: calc(100% - 38px);
    position: relative;
    display: flex;
    flex-direction: column;
`;

const TabButtons = styled.div`
    display: flex;
    justify-content: space-evenly;
    align-items: center;

    * {
        flex-grow: 0;
    }
`;

const TabButton = styled.div`
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
    padding: 10px 20px;
    background: #fff;
    color: #555;
    cursor: pointer;

    &.active {
        background: #D6EFFF;
        color: #11A9E2;
        border: 1px solid #11A9E2;
    }
`;

const CommentContainer = styled.div`
    padding: 15px;
    overflow: visible;
    margin-top: 0px;
    background: #fff;
    height: 100%;
    box-shadow: none;
    z-index: 0;
    background-color: #F1F1F1;
  `;

export const EditorCommentsPane = PresentationEditorController.withState(
    class EditorCommentsPane extends Component {
        state = {
            byViewer: false,
        }

        constructor() {
            super();

            this.subs = new Subscription();
        }

        componentWillUnmount() {
            this.subs.unsubscribe();
        }

        toggleByViewer = byViewer => {
            this.setState({ byViewer });
        }

        render() {
            const { transitionState, close, selectedPropertyPanelTabProps, presentation, currentSlide } = this.props;
            const { goToSlide } = selectedPropertyPanelTabProps;

            const { byViewer } = this.state;

            return (
                <>
                    <PropertyPanelHeader callback={() => PresentationEditorController.toggleComments()}>
                        Comments
                    </PropertyPanelHeader>
                    <CommentContainer>

                        <div>
                            <TabButtons>
                                <TabButton
                                    className={classNames({
                                        [`comment-tab`]: true,
                                        [`active`]: !byViewer,
                                    })}
                                    onClick={() => this.toggleByViewer(false)}
                                >Internal</TabButton>
                                <TabButton
                                    className={classNames({
                                        [`comment-tab`]: true,
                                        [`active`]: byViewer,
                                    })}
                                    onClick={() => this.toggleByViewer(true)}
                                >Viewer</TabButton>
                            </TabButtons>
                        </div>
                        <Bottom>
                            <CommentsPane
                                presentation={presentation}
                                currentSlide={currentSlide}
                                transitionState={transitionState}
                                goToSlide={goToSlide}
                                close={close}
                                byViewer={byViewer}
                            />
                        </Bottom>
                    </CommentContainer>
                </>
            );
        }
    }
);
